import { render, staticRenderFns } from "./AnswerReview.vue?vue&type=template&id=6532bd82&"
import script from "./AnswerReview.vue?vue&type=script&lang=js&"
export * from "./AnswerReview.vue?vue&type=script&lang=js&"
import style0 from "./AnswerReview.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports